const { faL } = require("@fortawesome/free-solid-svg-icons");
const { flatten } = require("mathjs/lib/cjs/entry/pureFunctionsAny.generated");

let baseUrl = "https://cp.hengbao.net.cn/";
let baseImgUrl = "https://cp.hengbao.net.cn:9010/dfs/";
let baseCardfaceUrl = "https://cp.hengbao.net.cn:9010/";

/*
isProductMode
true 正式环境 false 测试环境

正式环境
打包isProductMode = true
/config/index.js中
//部署到恒宝正式和测试环境
const assetsPath = '/'

测试环境
打包isProductMode = false
/config/index.js中
//部署到阿里云测试环境
const assetsPath = '/ykt/wpnIndex/diy/'
*/
// let isProductMode = false;//测试
let isProductMode = true; //生产


if (isProductMode) {
  baseUrl = "https://cp.hengbao.net.cn/";
  console.log("模式:生产模式");
} else {
  //baseUrl = "https://www.hbabc.xyz/ykt/wpnIndex/"
  //阿里云测试地址
  //baseUrl = "https://www.hbabc.xyz/"
  //baseUrl = "/qilu/"
  //恒宝测试地址
  baseUrl = "https://ts.hengbao.net.cn/";
  baseImgUrl = "https://ts.hengbao.net.cn:9010/dfs/";
  baseCardfaceUrl = "https://ts.hengbao.net.cn:9010/";
  console.log("模式:测试模式");
}
// console.log('baseUrl:' + baseUrl)
// console.log('baseImgUrl:' + baseImgUrl)
// console.log('baseCardfaceUrl:' + baseCardfaceUrl)

//四川中行
export const config_sczh = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0001",
  //提交订单
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",

  //图片地址
  frontCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BVF9E0R6AID11AADHtn4whvk991.png",
  frontCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BVF9E0TqAYvx6AADGSP9rEUQ712.png",
  backCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BXV9E0QyAYsjHAAOK2hxVDtw337.png",
  backCoverV: baseImgUrl + "group2/M00/00/00/rB-BXV9E0S2AFMexAAQke2r75nY801.png"
};

//齐鲁银行
export const config_ql = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01B1",

  submitOrder: baseUrl + "pos/order/submitOrder", //下单接口qiluSubmitOrder
  modify: baseUrl + "pos/order/modify", //修改图片
  getDecodeData: baseUrl + "pos/order/getDecodeData", //获取加密报文数据，流水号，手机号等参数
  queryBankDict: baseUrl + "pos/order/queryBankDict", //卡工艺获取
  queryOrder: baseUrl + "pos/order/queryOrder", //查询进度接口
  getProvinceInfoList: baseUrl + "pos/order/getSysRegionList", //获取省信息getProvinceInfoList
  getCityInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取市信息getCityInfoByParam
  getDistrictInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取区信息getDistrictInfoByParam
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  getEncryptData: baseUrl + "pos/order/getEncryptData", //加密数据接口
  refund: baseUrl + "pos/order/refund", //取消订单
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankBranchList",
  submitUserInfo: baseUrl + "pos/order/submitUserInfo", //提交
  qiluSubmitUserInfo: baseUrl + "pos/order/submitUserInfo", //提交用户信息地址电话
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: ""
};

//齐商银行
export const config_qs = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0085",

  submitOrder: baseUrl + "pos/order/submitOrder", //下单接口
  modify: baseUrl + "pos/order/modify", //修改图片
  getDecodeData: baseUrl + "pos/order/getDecodeData", //获取加密报文数据，流水号，手机号等参数
  queryBankDict: baseUrl + "pos/order/queryBankDict", //卡工艺获取
  queryOrder: baseUrl + "pos/order/queryOrder", //查询进度接口
  getProvinceInfoList: baseUrl + "pos/order/getSysRegionList", //获取省信息
  getCityInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取市信息
  getDistrictInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取区信息
  // getProvinceInfoList: baseUrl + "pos/order/getProvinceInfoList",//获取省信息
  // getCityInfoByParam: baseUrl + "pos/order/getCityInfoByParam",//获取市信息
  // getDistrictInfoByParam: baseUrl + "pos/order/getDistrictInfoByParam",//获取区信息
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  getEncryptData: baseUrl + "pos/order/getEncryptData", //加密数据接口
  refund: baseUrl + "pos/order/refund", //取消订单
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankBranchList",
  submitUserInfo: baseUrl + "pos/order/submitUserInfo", //提交
  qiShangSubmitUserInfo: baseUrl + "pos/order/submitUserInfo", //提交用户信息地址电话
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",

  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: ""
};

//徽商银行
export const config_hs = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  baseCardfaceUrl: baseCardfaceUrl,
  bankCode: "0051",

  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  // unifiedOrder: baseUrl + "pos/order/pay",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  frontCoverH: baseCardfaceUrl+ "bank_layout/0051/front/0051_0_1.png",
  frontCoverV: baseCardfaceUrl+ "bank_layout/0051/back/0051_0_2.png",
  backCoverH: baseCardfaceUrl+ "bank_layout/0051/front/0051_1_2.png",
  backCoverV: baseCardfaceUrl+ "bank_layout/0051/back/0051_1_2.png",

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
};

//demo------------------------------------------------------------
export const config_demo = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  baseCardfaceUrl: baseCardfaceUrl,
  bankCode: "0051",

  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  // unifiedOrder: baseUrl + "pos/order/pay",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  frontCoverH: baseCardfaceUrl+ "",
  frontCoverV: baseCardfaceUrl+ "",
  backCoverH: baseCardfaceUrl+ "",
  backCoverV: baseCardfaceUrl+  "",

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码

  // AI 文生图
  AI_text_to_image: baseUrl + "pos/order/text2image",

  // AI 图文生图
  AI_image_text_to_image: baseUrl + "pos/order/image2image",

  // AI 人像重绘
  AIimage_to_image: baseUrl + "pos/order/figureredraw",

  // AI 人像重绘返回结果
  // AI_figureredrawresult: baseUrl + "pos/order/figureredrawresult",

  //pic2Base64
  pic2Base64: baseUrl + "pos/order/pic2Base64",

  // 删除原图url
  delSourcePic: baseUrl + "pos/order/delSourcePic",
  
  // 图片转换base64
  uploadPic: baseUrl + "pos/order/uploadPic",

  // 查询请求记录
  getRecords: baseUrl + "pos/order/getRecords",

  // 申请确定后删除所有图片
  delRecords: baseUrl + "pos/order/delRecords",

  // ai换脸
  face_swap: baseUrl + "pos/order/face_swap",
  
  // 收藏
  collectible: baseUrl + "pos/order/collectible",
   
  // 收藏夹查询
  getRecords: baseUrl + "pos/order/getRecords",

  // 获取次数
  initResidualNums: baseUrl + "pos/order/initResidualNums",

  // 减少次数
  decrResidualNums: baseUrl + "pos/order/decrResidualNums"
  
};

//泰州公交
export const config_tai = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01F6DIY",   

  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  // unifiedOrder: baseUrl + "pos/order/pay",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
};

//乌鲁木齐商行
export const config_wlmqsh = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0049",

  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankBranchList",
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",

  frontCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BVF9E0reAWu6SAAKI07R10Fk425.png",
  frontCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BVF9E0s-AOXlrAAH0ZgG5wTg380.png",
  backCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BXV9E0qeACyoGAANbPBisva0730.png",
  backCoverV: baseImgUrl + "group2/M00/00/00/rB-BXV9E0sOABVAzAAP7d9VMQAU616.png"
};

//深圳农商行
export const config_shzhnsh = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0038",

  submitOrder: baseUrl + "pos/order/submitCardBase64",
  modify: baseUrl + "pos/order/editCardBase64",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankBranchList",
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",

  frontCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BVF9EzsiAKfOfAAIa5yDz4fI079.png",
  frontCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BXV9E5guAZY__AAJPz5PpOnM342.png",
  backCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BXV9EzoiAN-5WAAKnNSLNdhM699.png",
  backCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BXV9EztaAJjaCAAPmEBxhRtc645.png",

  yellow_backCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BVF9EzqqARS1kAAK7cgwqmP4098.png",
  yellow_backCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BVF9EzuKALCadAAP245FxpWs158.png",
  white_backCoverH:
    baseImgUrl + "group2/M00/00/00/rB-BXV9EzoiAN-5WAAKnNSLNdhM699.png",
  white_backCoverV:
    baseImgUrl + "group2/M00/00/00/rB-BXV9EztaAJjaCAAPmEBxhRtc645.png"
};

//四川天府银行
export const config_schtnf = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01A2",

  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankBranchList",
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",

  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: ""
};

//四川绵阳商行
export const config_schmysh = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0015",

  submitOrder: baseUrl + "pos/order/submitOrder",
  queryOrder: baseUrl + "pos/order/queryOrder",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  getExpressageInfo: baseUrl + "pos/order/getExpressageInfo",

  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: ""
};
//陕西信合
export const config_shxxh = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0026",

  submitOrder: "pos/order/submitOrder", //提交订单
  modify: "pos/order/modify", //修改订单
  queryOrder: "pos/order/queryOrder",
  getLayoutImageByBankCode: "pos/order/getLayoutImageByBankCode", //获取卡面图片
  queryBankDict: "pos/order/queryBankDict",
  getSmsCode: "pos/order/getCore/", //获取短信验证码接口
  getFlowNoes: "pos/order/getBankSerialNumbers", //查询银行流水号
  submitUserInfo: "pos/order/submitUserInfo", //提交用户信息
  unifiedOrder: "pay/order/0026/unifiedOrder", //统一下单接口
  refund: "/pos/order/refund", //取消订单，退款
  decodeData: "pos/order/decodeData", //解密
  encodeData: "pos/order/encodeData" //加密
};

// 青岛农商银行
export const config_qingdao = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0076QDNSH",
  
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //获取网点信息
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  
  // 图片
  frontCoverH:"",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

}

export const config_baseUrl = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  baseCardfaceUrl: baseCardfaceUrl
};

//是否是四川中行
export function isSczhBank(bankCode) {
  let pattern = /^0001/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}
// 是否是湖南银行
 export function isHunanBank(bankCode) {
  let pattern = /^0035/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}

export function isQiluBank(bankCode) {
  let pattern = /^01B1/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}

export function isShzhnshBank(bankCode) {
  let pattern = /^0038/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}
//四川天府银行
export function isSchtnfBank(bankCode) {
  let pattern = /^01A2/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}
//四川绵阳商行
export function isSchmyshBank(bankCode) {
  let pattern = /^0015/;
  console.log("pattern: " + pattern);
  return pattern.test(bankCode);
}


// 洪城通DIY卡面
export const config_hongcheng = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0131",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
    getProvinceInfoList: baseUrl + "pos/order/getSysRegionList", //获取省信息getProvinceInfoList
  getCityInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取市信息getCityInfoByParam
  getDistrictInfoByParam: baseUrl + "pos/order/getSysRegionList", //获取区信息getDistrictInfoByParam
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  isProductMode: isProductMode,
};


// 郑州一卡通
export const config_zz = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0175",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",
  // 交易金额
  isProductMode: isProductMode,
};

// 襄阳公交DIY
export const config_xy = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01D5",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  // 交易金额
  isProductMode: isProductMode,
};
// 合肥通DIY
export const config_hf = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01BCDIY",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  // 交易金额
  isProductMode: isProductMode,
};
export const config_app_xy = {
   baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "01D5",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  // 襄阳公交面值金额
  isProductMode: isProductMode,
}
// 湖南银行
export const config_hunan = {
  baseUrl: baseUrl,
  bankCode: "0035",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  uploadFile: baseUrl + "/pos/order/uploadFile", //图片传输
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryOrder: baseUrl + "pos/order/queryOrder"
};

// // 迪拜及时制卡系统
export const config_dubaiCard = {
  baseUrl: baseUrl,
  submitOrder: baseUrl + "pos/device/submitOrder",
  queryOrder: baseUrl + "pos/device/queryOrder",
  queryOrders: baseUrl + "pos/device/queryOrders",
  queryOrdersByPhone:baseUrl +"pos/device/queryOrdersByPhone"
}
//支付配置
export const config_commonPay = {
  baseUrl: baseUrl,
  aliPayH5: baseUrl + "pay/order/alipay/unifiedOrder", //支付宝支付H5
  // aliPayH5: baseUrl + "pos/order/pay", //支付宝支付H5
  initAilPay: baseUrl + "pay/order/alipay/initAilPay" //获取Appid
  
}
// 宁波公交
export const config_nb = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,

  bankCode01: "01F7DIY", //宁波公交
  bankName01: "宁波公交", //宁波公交
  bankCode02: "01F7DIYCDART", //宁波彩豆艺术特长培训有限公司
  bankName02: "宁波彩豆艺术特长培训有限公司",//宁波彩豆艺术特长培训有限公司
  bankCode03: "01F7DIYJYCTR", //宁波见永文化科技有限公司
  bankName03: "宁波见永文化科技有限公司",//宁波见永文化科技有限公司

  isProductMode: isProductMode,
  
  smart_cutouts: baseUrl + "/pos/order/smart_cutouts",
  getTopic: baseUrl + "pos/order/getTopic",
  getTopicImages:baseUrl+"pos/order/getTopicImages",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  
  

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  isProductMode: isProductMode,

};
//建行demo
export const config_ccb = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,

  bankCode01: "0004", 
  bankName01: "中国建设银行",
  bankCode02: "0004",
  bankName02: "中国建设银行",
  bankCode03: "0004",
  bankName03: "中国建设银行",

  isProductMode: isProductMode,
  
  smart_cutouts: baseUrl + "/pos/order/smart_cutouts",
  getTopic: baseUrl + "pos/order/getTopic",
  getTopicImages:baseUrl+"pos/order/getTopicImages",

  getCardTypeList:
    baseUrl + "pos/order/getCardTypeList?companyType=2&bankCode=01D5", //获取卡种类列表
  getBranchInfoNewByParam: baseUrl + "pos/order/getBranchInfoNewByParam", //网点查询
  submitOrder: baseUrl + "pos/order/submitOrder",
  modify: baseUrl + "pos/order/modify",
  queryBankDict: baseUrl + "pos/order/queryBankDict",
  queryOrder: baseUrl + "pos/order/queryOrder",
  refund: baseUrl + "pos/order/refund",
  initWXJSSDKConfigInfo: baseUrl + "pay/order/wx/initWXJSSDKConfigInfo",
  getJSAPIOpenid: baseUrl + "pay/order/wx/getJSAPIOpenid",
  unifiedOrder: baseUrl + "pay/order/wx/unifiedOrder",
  queryBankSerialNumbers: baseUrl + "pos/order/queryBankSerialNumbers",
  queryBranchList: baseUrl + "pos/order/queryBranchList",
  queryBankBranchList: baseUrl + "pos/order/queryBankSubList", //通过总行编码查询分行信息
  submitUserInfo: baseUrl + "pos/order/submitUserInfo",
  getLayoutImageByBankCode: baseUrl + "pos/order/getLayoutImageByBankCode",
  //支付成功通知接口
  appNotify: "/pay/order/wx/appNotify",
  queryVoucher: baseUrl + "pos/order/queryVoucher", //查询优惠券

  // // 手机验证码
  getCore: baseUrl + "pos/order/getCore/", //手机号获取验证码
  verifyCore: baseUrl + "pos/order/verifyCore/", //验证手机号验证码
  initH5Pay: baseUrl + "pay/order/wx/initH5Pay", //H5支付方式初始化获取appid
  
  

  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

  isProductMode: isProductMode,

};


// 中原银行
export const config_zy = {
  baseUrl: baseUrl,
  baseImgUrl: baseImgUrl,
  bankCode: "0069DIY",

  decryptDataByZYBank: baseUrl + "pos/order/decryptDataByZYBank", //解密数据接口
  queryOrder: baseUrl + "pos/order/querySingleOrder", //查询接口（次数限制）
  submitOrderZYBank: baseUrl  + "pos/order/submitOrderZYBank", //下单接口



  // 图片
  frontCoverH: "",
  frontCoverV: "",
  backCoverH: "",
  backCoverV: "",

};







// exports.config_sczh = config_sczh;
// exports.config_hs = config_hs;
// exports.config_ql = config_ql;
// exports.config_qs = config_qs;
// exports.isSczhBank = isSczhBank;
// exports.isQiluBank = isQiluBank;
// exports.isShzhnshBank = isShzhnshBank;
// exports.config_wlmqsh = config_wlmqsh;
// exports.config_shzhnsh = config_shzhnsh;
// exports.baseCardfaceUrl = baseCardfaceUrl;
// exports.config_schtnf = config_schtnf;
// exports.isSchtnfBank = isSchtnfBank;
// exports.isSchmyshBank = isSchmyshBank;
// exports.isHunanBank = isHunanBank;
// exports.config_schmysh = config_schmysh;
// exports.config_shxxh = config_shxxh;
// exports.config_baseUrl = config_baseUrl;
// exports.config_xy = config_xy;
// exports.config_app_xy = config_app_xy;
// exports.config_hunan = config_hunan;
// exports.config_DubaiCard = config_dubaiCard;
// exports.config_qingdao = config_qingdao
// exports.config_commonPay = config_commonPay
// exports.config_hongcheng = config_hongcheng
// exports.config_zz = config_zz
// exports.config_tai = config_tai
// exports.config_demo = config_demo




// WEBPACK FOOTER //
// ./src/common/config.js